import { render, staticRenderFns } from "./TwoAthletesSoccerBackground.vue?vue&type=template&id=0c95eb43&"
import script from "./TwoAthletesSoccerBackground.vue?vue&type=script&lang=js&"
export * from "./TwoAthletesSoccerBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports